import type { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'components/Grid/Grid';
import { ImageSlidesDesktop, ImageSlidesMobile } from 'components/ImageSlides';
import { StructuredModal } from 'components/StructuredModal/StructuredModal';
import { useBreakpoints } from 'hooks/useBreakpoints';
import React, { FC } from 'react';
import styles from './ImageModal.module.scss';

interface IImageModalProps {
  closeModal: (state: boolean) => any;
  modalOpen?: boolean;
  images?: ContentImageEntry[];
}

export const ImageModal: FC<IImageModalProps> = ({ modalOpen = false, closeModal, images }) => {
  const { browser } = useBreakpoints();
  const isDesktopOrLarger = browser.is.desktop;
  const ImageSlides = isDesktopOrLarger ? ImageSlidesDesktop : ImageSlidesMobile;

  return (
    <StructuredModal
      modalState={[modalOpen, () => closeModal(modalOpen)]}
      aria={{ modal: true, labelledby: 'imageModal' }}
      className={styles.modalContainer}
    >
      <div>
        <Grid container justifyContent="center" alignContent="center">
          <Grid xs={12}>
            <div className={styles.imageSlidesWrapper}>
              <ImageSlides images={images} variant="images-only" />
            </div>
          </Grid>
        </Grid>
      </div>
    </StructuredModal>
  );
};
